import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { StyledCheckbox, CheckboxLabel, CheckboxContainer, styledSystemKeys } from "./checkbox.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Checkbox = function Checkbox(props) {
  var id = props.id,
    label = props.label,
    checked = props.checked,
    _onChange = props.onChange,
    align = props.align,
    name = props.name,
    disabled = props.disabled,
    hideLabel = props.hideLabel,
    className = props.className,
    ellipse = props.ellipse,
    tabIndex = props.tabIndex;
  var checkboxMarkup = /*#__PURE__*/_jsx(StyledCheckbox, {
    id: id,
    type: "checkbox",
    role: "checkbox",
    "aria-checked": checked,
    checked: checked,
    name: name || undefined,
    disabled: disabled,
    hideLabel: hideLabel,
    tabIndex: tabIndex || undefined,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    }
  });
  var labelMarkup = /*#__PURE__*/_jsx(CheckboxLabel, {
    htmlFor: id,
    disabled: disabled,
    hideLabel: hideLabel,
    ellipse: ellipse,
    align: align,
    children: label
  });
  return /*#__PURE__*/_jsxs(CheckboxContainer, _objectSpread(_objectSpread({
    className: className,
    disabled: disabled,
    hideLabel: hideLabel,
    title: label
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [align === "right" ? labelMarkup : checkboxMarkup, align === "right" ? checkboxMarkup : labelMarkup]
  }));
};
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.oneOf([true, false, "mixed"]),
  disabled: PropTypes.oneOf([true, false]),
  hideLabel: PropTypes.oneOf([true, false]),
  align: PropTypes.oneOf(["left", "right"]),
  name: PropTypes.string,
  className: PropTypes.string,
  ellipse: PropTypes.oneOf([true, false]),
  tabIndex: PropTypes.any
};
Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  hideLabel: false,
  align: "left",
  ellipse: false
};
export default Checkbox;